import React, {Component,Fragment} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import Loader from "../loader";
import Hero from "../components/hero";
import Bar from "../aldComponents/bar";
import FixedBar from "../aldComponents/fixed-bar";
import DateCounter from "../components/date-counter";
import CustomSection from "../components/custom-section";
import ModalDon from "../components/modal-don";
import DeviseChoiceModal from "../components/devise-choice";
import Products from "../components/products";

import VideoPlayer from "../aldComponents/video-player";
import BlockDon from "../aldComponents/block-don";
import DonSection from "../components/don-section";
import {Tabs} from "antd";
import ContentTabs from "../aldComponents/content-tabs";
import BarPartner from "../aldComponents/bar-partner";
import BarCount from "../aldComponents/bar-count";
import RenderConfetti from "../components/confetti";

export default class HomeAld extends Component{

    modalDon=null
    showModalDon=(_defaultSelectedProducts=[])=>{
        this.modalDon.show(_defaultSelectedProducts)
    }

    render(){
        let context={...this.props.context,actions:{showModalDon:this.showModalDon}}

        const {org,config}=context

        const {isMobile}=context

        const {campagneData,campagneTarget} = this.props

        const campagneDataConfig=campagneData?.config || {}

        const title=campagneDataConfig.metaTitle || campagneData.label
        const description=campagneDataConfig.metaDescription || null
        const image=campagneDataConfig.metaImage
        const video=campagneDataConfig.metaVideo

        const hideBar=campagneData?.config?.hideBar || false

        const totalNb=campagneData.stats.total.count.total



        if(this.props.loading){
            return (
                <div>
                    <Meta seo={campagneDataConfig} context={context} title={title} description={description} image={image} video={video}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div className={"campagne-page"}>
                <Meta seo={campagneDataConfig} context={context} title={title} description={description} image={image} video={video}/>
                <Header context={context} campagneData={campagneData}/>

                {isMobile &&(
                    <Hero context={context} campagneData={campagneData} campagneTarget={campagneTarget} noVideo/>
                )}

                <div className={"container"}>

                    {!isMobile && (
                        <Hero context={context} campagneData={campagneData} campagneTarget={campagneTarget} noVideo/>
                    )}

                    {isMobile && (
                        <div>
                            {!hideBar && campagneData.type === "PARTNER" &&(
                                <BarPartner context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}

                            {!hideBar && campagneData.type === "COUNT" &&(
                                <BarCount context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}

                            {!hideBar && !campagneData.type && (
                                <Bar context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}
                        </div>
                    )}


                    <div className={"row mt-3"} style={{display: "flex", alignItems: "stretch"}}>
                        <div className="col-xs-12 col-lg-8">
                            <VideoPlayer context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                        </div>

                        <div className="col-xs-12 col-lg-4 mt-3 mt-lg-0">
                            <BlockDon context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                        </div>
                    </div>


                    <div style={{marginBottom: 15}}>
                        <Products forceSubmit context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                    </div>


                    {!isMobile && (
                        <div style={{marginTop: 15}}>
                            {!hideBar && campagneData.type === "PARTNER" &&(
                                <BarPartner context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}

                            {!hideBar && campagneData.type === "COUNT" &&(
                                <BarCount context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}

                            {!hideBar && !campagneData.type && (
                                <Bar context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            )}
                        </div>
                    )}


                    {isMobile && totalNb > 0 && (
                        <div style={{marginTop: 50}}>
                            <DonSection context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                        </div>
                    )}

                    {isMobile && (
                        <div style={{marginTop: 50}}>
                            <ContentTabs context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                        </div>
                    )}

                    {!isMobile && (
                        <div className={"row mt-5"} style={{display: "flex", alignItems: "stretch"}}>
                            <div className="col-xs-12 col-lg-8">
                                <ContentTabs context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            </div>

                            <div className="col-xs-12 col-lg-4">
                                {totalNb>0 &&(
                                    <DonSection forceMobile context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                                )}
                            </div>
                        </div>
                    )}


                </div>


                <Footer context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>


                {campagneData?.config?.forceCelebration &&(
                    <RenderConfetti/>
                )}

                <FixedBar context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                <ModalDon context={context} campagneData={campagneData} campagneTarget={campagneTarget}
                          getRef={(ref) => this.modalDon = ref}/>
                <DeviseChoiceModal context={context} campagneData={campagneData}/>
            </div>
        )
    }
}
